import React, { useCallback, useState } from "react";
import { GoCheckCircleFill } from "react-icons/go";
import ConfirmPassword from "./ConfirmPassword";
import ForgotPassword from "./ForgotPassword";
import { showSuccess } from "../../../helpers/alerts";
function IndexOfForgotPassword() {
  const [current, setCurrent] = useState(1);
  const nextPage = useCallback(() => {
    setCurrent((prev) => prev + 1);
  }, []);
  if (current == 3) {
    showSuccess("Password updated successfully!");
  }
  return (
    <div>
      {current == 1 && <ForgotPassword nextPage={nextPage} />}
      {current == 2 && <ConfirmPassword nextPage={nextPage} />}
      {/* {current == 3 && (
        <div>
          <div className="flex justify-center items-center my-5">
            <GoCheckCircleFill color="#52c41a" size={50} />
          </div>
          <h5 className=" text-center text-xl mb-4 font-medium">
            Password updated successfully
          </h5>
        </div>
      )} */}
    </div>
  );
}

export default IndexOfForgotPassword;
